import React, { useState,useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { Home, Info, DesignServices, Groups, ContactMail } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";

const Topnavbardata = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [value, setValue] = useState(0);
  const [mobileNavActive, setMobileNavActive] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (section) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }
    setMobileNavActive(false);
  };
 
  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, [location]);

  return (
    <>
      {/* Desktop Navbar (md+ screens) */}
      {!isMobile && (
        <header id="header" className="header d-flex align-items-center fixed-top">
          <div className="container-fluid container-xl position-relative d-flex align-items-center">
            <a href="/" className="logo d-flex align-items-center me-auto">
              <img src="logo6.png" alt="Logo" style={{ height: "50px", display: "block" }} />
            </a>

              <nav id="navmenu" className={`navmenu ${mobileNavActive ? "mobile-nav-active" : ""}`}>
                <ul className={`${mobileNavActive ? 'd-block':''}`} style={mobileNavActive ? { height: "60vh" } : {}}>
               
                  <li><a href="#" onClick={() => handleNavClick("hero")}><Home />&nbsp;Home</a></li>
                  <li><a href="#" onClick={() => handleNavClick("about")}>About</a></li>
                  <li><a href="#" onClick={() => handleNavClick("services")}>Services</a></li>
                  <li><a href="#" onClick={() => handleNavClick("contact")}>Contact</a></li>
                </ul>

                {/* Mobile Menu Toggle Button */}
               <i className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? "bi-x" : "bi-list"}`} onClick={() => setMobileNavActive(!mobileNavActive)}></i>
          
            </nav>
          </div>
        </header>
      )}

      {/* Mobile Bottom Navigation (sm & xs screens) */}
      {isMobile && (
        <>
          <div className="text-center p-2" style={{ backgroundColor: "#37517e" }}>
            <img src="logo6.png" alt="" style={{ height: "50px" }} />
          </div>
          <BottomNavigation
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            showLabels
            sx={{ position: "fixed", bottom: 0, left: 0, right: 0, width: "100%", boxShadow: 3, zIndex: 1000 }}
          >
            <BottomNavigationAction label="Home" icon={<Home />} href="#" onClick={() => handleNavClick("hero")} />
            <BottomNavigationAction label="About" icon={<Info />} href="#" onClick={() => handleNavClick("about")} />
            <BottomNavigationAction label="Services" icon={<DesignServices />} href="#" onClick={() => handleNavClick("services")} />
            <BottomNavigationAction label="Contact" icon={<ContactMail />} href="#" onClick={() => handleNavClick("contact")} />
          </BottomNavigation>
        </>
      )}
    </>
  );
};

export default Topnavbardata;
